// Expresiones regulares para validaciones
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,12}$/;
export const PHONE_REGEX = /^[0-9]{9,15}$/;
export const RUC_REGEX = /^[0-9]{11}$/;

// Funciones de validación
export const validateEmail = (email: string): string | null => {
  if (!email) return 'El email es requerido';
  if (!EMAIL_REGEX.test(email)) return 'Formato de email inválido';
  return null;
};

export const validatePassword = (password: string): string | null => {
  if (!password) return 'La contraseña es requerida';
  if (password.length < 8 || password.length > 12) {
    return 'La contraseña debe tener entre 8 y 12 caracteres';
  }
  if (!PASSWORD_REGEX.test(password)) {
    return 'La contraseña debe contener al menos 1 mayúscula, 1 minúscula y 1 carácter especial';
  }
  return null;
};

export const validateConfirmPassword = (password: string, confirmPassword: string): string | null => {
  if (!confirmPassword) return 'Confirmar contraseña es requerido';
  if (password !== confirmPassword) return 'Las contraseñas no coinciden';
  return null;
};

export const validatePhone = (phone: string): string | null => {
  if (!phone) return 'El teléfono es requerido';
  if (!PHONE_REGEX.test(phone)) return 'Formato de teléfono inválido';
  return null;
};

export const validateRUC = (ruc: string): string | null => {
  if (!ruc) return 'El RUC es requerido';
  if (!RUC_REGEX.test(ruc)) return 'El RUC debe tener 11 dígitos';
  return null;
};

export const validateRequired = (value: string, fieldName: string): string | null => {
  if (!value || value.trim() === '') return `${fieldName} es requerido`;
  return null;
};